import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onSaveColumnPrefs", "isModalOpen", "setIsModalOpen", "labels"];
// @flow

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as React from 'react';
import PropTypes from 'prop-types';
import CustomizeColumnsModal from './CustomizeColumnsModal';

var ModalWrapper = function ModalWrapper(_ref) {
  var instance = _ref.instance;

  var _instance$customizeCo = instance.customizeColumnsProps,
      _onSaveColumnPrefs = _instance$customizeCo.onSaveColumnPrefs,
      isModalOpen = _instance$customizeCo.isModalOpen,
      setIsModalOpen = _instance$customizeCo.setIsModalOpen,
      labels = _instance$customizeCo.labels,
      rest = _objectWithoutProperties(_instance$customizeCo, _excluded);

  if (isModalOpen) {
    return /*#__PURE__*/React.createElement(CustomizeColumnsModal, _extends({}, rest, labels, {
      isOpen: isModalOpen,
      setIsModalOpen: setIsModalOpen,
      columnDefinitions: instance.allColumns,
      originalColumnDefinitions: instance.columns,
      onSaveColumnPrefs: function onSaveColumnPrefs(updatedColDefs) {
        var hiddenIds = updatedColDefs.filter(function (colDef) {
          return !colDef.isVisible;
        }).map(function (colDef) {
          return colDef.id;
        });
        instance.setHiddenColumns(hiddenIds);

        if (typeof instance.setColumnOrder === 'function') {
          instance.setColumnOrder(updatedColDefs.map(function (colDef) {
            return colDef.id;
          }));
        } else {
          // eslint-disable-next-line no-console
          console.warn("Column order can not be updated. Did you forget to add 'useColumnOrder' in 'useDatagrid'");
        }

        if (typeof _onSaveColumnPrefs === 'function') {
          _onSaveColumnPrefs(updatedColDefs);
        }
      }
    }));
  }

  return null;
};

ModalWrapper.propTypes = {
  instance: PropTypes.object.isRequired
};
export default ModalWrapper;